import {Component, HostBinding, Input} from '@angular/core';
import {ValidationState} from '@catmodules/widgets/shared/states';

const componentBaseName = 'item-state';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-item-state',
  templateUrl: './item-state.component.html',
  styleUrls: ['./item-state.component.scss'],
})
export class ItemStateComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() label: string;

  isValid = true;

  constructor() {
  }

  @Input('state')
  set state(state: any) {
    this.isValid = state === ValidationState.VALID;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/widgets/explorer/components/item-state/item-state.component.ts